import { render, staticRenderFns } from "./ClientSuplier.vue?vue&type=template&id=02277a60&scoped=true"
import script from "./ClientSuplier.vue?vue&type=script&lang=js"
export * from "./ClientSuplier.vue?vue&type=script&lang=js"
import style0 from "./ClientSuplier.vue?vue&type=style&index=0&id=02277a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02277a60",
  null
  
)

export default component.exports